// extracted by css-extract-rspack-plugin
export default {"PaneLayout":"bN6F0"};